var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ui toogle checkbox custom" }, [
    _c("input", {
      attrs: { name: _vm.name, type: "checkbox" },
      domProps: { checked: _vm.isChecked(_vm.name) },
      on: {
        click: function($event) {
          return _vm.toggleCheckbox($event)
        }
      }
    }),
    _vm._v(" "),
    _c("label", [
      _c("div", { staticClass: "facet-element-container" }, [
        _c("b", [_vm._v(_vm._s(_vm.displayName))]),
        _vm._v(" "),
        _c("i", [_vm._v(_vm._s(_vm.type))])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }